export function Placeholder({
  eyebrow,
  title,
  lede,
  milestone,
}: {
  eyebrow: string;
  title: string;
  lede: string;
  milestone: string;
}) {
  return (
    <div className="placeholder">
      <span className="eyebrow">{eyebrow}</span>
      <h1>{title}</h1>
      <p>{lede}</p>
      <div className="placeholder-tag">{milestone}</div>
    </div>
  );
}
